import { useFlag } from '@calendly/feature-check-react'
import { useMemo } from 'react'

import { useEventType } from 'features/event_type_provider'

import { getWorkflowsOwner } from './get_workflows_owner'
import { useFetchAvailableWorkflowsQuery } from '../../../api'
import { useEventTypeEditorSidebar } from '../../../hooks'

// Loads the owner's full automation catalog (not filtered to the current event type)
// for the CRUD "Add an automation" selection menu.
export const useAvailableWorkflows = ({ withAdminManaged = true } = {}) => {
  const workflowsExtractionEnabled = useFlag('raven_workflows_extraction')
  const { creator_id: creatorId, isMETParent, profile } = useEventType()
  const { ownerType: sidebarOwnerType, ownerId: sidebarOwnerId } = useEventTypeEditorSidebar()

  const ownerType = sidebarOwnerType === undefined ? profile?.owner_type : sidebarOwnerType
  const ownerId = sidebarOwnerId === undefined ? profile?.owner_id : sidebarOwnerId
  const { id: workflowOwnerId, type: workflowOwnerType } = getWorkflowsOwner({ ownerType, ownerId, creatorId })

  const queryParams = useMemo(() => {
    if (isMETParent) {
      return {
        isMETParent,
        ...(workflowOwnerId && {
          ownerId: workflowOwnerId,
          ownerType: workflowOwnerType
        }),
        withAdminManaged
      }
    }

    return {
      isMETParent,
      ownerId: workflowOwnerId,
      ownerType: workflowOwnerType,
      withAdminManaged
    }
  }, [isMETParent, workflowOwnerId, workflowOwnerType, withAdminManaged])

  const { data } = useFetchAvailableWorkflowsQuery(queryParams, {
    skip: !workflowsExtractionEnabled || !queryParams,
    refetchOnMountOrArgChange: true
  })

  return useMemo(() => data?.list || [], [data])
}
